export default function getImage(src: string): string {
    return `https://image.tmdb.org/t/p/original${src}`
}